// extracted by mini-css-extract-plugin
module.exports = {"root":"_1Sd4_","theme-based":"_2aNji","themeBased":"_2aNji","content":"_4yw_m"};